import {BouncingLoaderContainer, BouncingLoaderDiv} from './ChatViewStyles'

const BouncingLoader = () => {
  return (
    <BouncingLoaderContainer data-testid="bouncing-loader-container">
      <BouncingLoaderDiv data-testid="bouncing-loader-div" />
      <BouncingLoaderDiv data-testid="bouncing-loader-div" />
      <BouncingLoaderDiv data-testid="bouncing-loader-div" />
    </BouncingLoaderContainer>
  )
}

export default BouncingLoader
